<template>
  <div class="income">
    <div class="flex mdmax:flex-col mdmax:items-start items-end gap-5 mdmax:gap-4 mb-6">
      <div class="w-1/2 mdmax:w-full flex items-center gap-5">
        <div class="w-1/2">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('report.month') }}</label>
          <CustomSelect :options="monthList" v-model="selectedMonth" :default="selectedMonth"
            @change="triggerDateChange()" />
        </div>
        <div class="w-1/2">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('report.year') }}</label>
          <CustomSelect :options="yearList" v-model="selectedYear" :default="selectedYear"
            @change="triggerDateChange()" />
        </div>
      </div>
      <div class="w-1/2 mdmax:w-full flex mdmax:flex-col mdmax:items-start justify-between items-end gap-5 mdmax:gap-4">
        <div class="w-1/2 mdmax:w-full pb-3 mdmax:pb-0 text-sm">
          {{ $t('report.totalPayout') }}: <span class="inline-block font-bold text-xl">{{ paymentReports?.total |
            currencyFormat }}</span>
        </div>
        <div class="w-1/2 mdmax:w-full flex justify-end mdmax:justify-start">
          <Button buttonText="Export Data" size="big" @action="downloadReports()"
            :icon="() => import('@/components/Icons/Export')" />
        </div>
      </div>
    </div>
    <div class="">
      <TableComponent :columns="columns" :list="filteredData" compact>
        <template slot="table-row" slot-scope="{ entry, column }">
          <div v-if="column.field === 'date'">{{ entry.date | formatDate }}</div>
          <div v-else-if="column.field === 'transaction'">
            <p class="mb-1">{{ entry.package_origin }} - {{ entry.package_destination }}</p>
            <p class="text-xs text-neutral-500">AWB: {{ entry.package_shipment_awb }}</p>
          </div>
          <div v-else-if="column.field === 'payment_amount'">
            {{ entry.payment_amount | currencyFormat }}
          </div>
          <span v-else>{{ entry[column.field] || '-' }}</span>
        </template>
      </TableComponent>
      <template v-if="filteredData?.length > 0">
        <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">{{ $t('report.show') }} {{ start }} - {{
          end }} {{ $t('report.from') }}
          {{ totalRecords }}</div>
        <div class="mt-8 flex justify-end mdmax:justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
          <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize"
            @onPageChange="onPageChange" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { formatDate, currencyFormat } from '@/util'
export default {
  filters: {
    formatDate,
    currencyFormat
  },
  components: {
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    // Search: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Search'),
    // Transaction: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Transaction'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    Button: () => import(/* webpackChunkName: "button" */ '@/components/Forms/Button')
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: null,
      theMonths: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      tabList: [
        {
          title: 'Semua',
          active: true
        },
        {
          title: 'Dana Masuk',
          active: false
        },
        {
          title: 'Dana Keluar',
          active: false
        }
      ],
      selectedTab: '',
      data: [
        {
          date: '16 Oct 2021',
          status: 'Process',
          type: 'Pengiriman',
          transaction: {
            orderId: 'LN-5631',
            awb: 'AWB: 878931904123789'
          },
          income: '+Rp 30.000',
          balance: 'Rp 35.890.000'
        }
      ],
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  mounted() {
    const date = new Date()
    this.selectedMonth = this.theMonths[date.getMonth()]
    this.getReportList()
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('summary', ['paymentReports']),
    yearList() {
      return this.generateArrayOfYears()
    },
    monthList() {
      return this.theMonths
    },
    filteredData() {
      return this.paymentReports?.summary
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    },
    columns() {
      return [
        { label: this.$t('report.date'), field: 'date' },
        { label: this.$t('report.status'), field: 'package_status' },
        { label: this.$t('report.year'), field: 'payment_type' },
        { label: this.$t('report.transaction'), field: 'transaction' },
        { label: this.$t('report.shippingCost'), field: 'payment_amount' }
      ]
    }
  },
  methods: {
    ...mapActions('summary', ['getPaymentReports', 'paymentReportsDownload']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    downloadReports() {
      const dateParams = this.getDateFromMonth(this.theMonths.indexOf(this.selectedMonth), this.selectedYear)
      this.paymentReportsDownload({
        params: {
          start_date: dateParams.startDate,
          end_date: dateParams.endDate
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Payment Report - ${this.selectedMonth} ${this.selectedYear}.csv`)
        document.body.appendChild(link)
        link.click()
      })
    },
    triggerDateChange() {
      this.getReportList()
    },
    getReportList(page = 1) {
      const dateParams = this.getDateFromMonth(this.theMonths.indexOf(this.selectedMonth), this.selectedYear)
      this.showLoading()
      this.getPaymentReports({
        params: {
          page: page,
          per_page: this.pageSize,
          search_keyword: '',
          sort: 'DESC',
          start_date: dateParams.startDate,
          end_date: dateParams.endDate
        }
      }).then(res => {
        if (res.data.data) {
          this.totalRecords = res.data.meta.total_item
        }
        this.hideLoading()
      })
    },
    getDateFromMonth(month, year) {
      const date = new Date()
      const firstDay = dayjs(String(new Date(year, month, 1))).format('YYYY-MM-DD')
      const lastDay = dayjs(String(new Date(year, month + 1, 0))).format('YYYY-MM-DD')
      return {
        startDate: firstDay,
        endDate: lastDay
      }
    },
    selectTab(tab) {
      this.tabList.forEach(item => (item.active = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    onPageChange(page) {
      this.currentPage = page
      this.getReportList(page)
    },
    generateArrayOfYears() {
      var max = new Date().getFullYear()
      var min = max - 9
      var years = []
      for (var i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
